import type { StepCard } from '../types/landing'

export const steps: StepCard[] = [
  {
    id: 'zone',
    index: '01',
    title: 'Pick a learning zone',
    copy: "Choose the volume and activity that fit the learner's current level.",
  },
  {
    id: 'print',
    index: '02',
    title: 'Print and play',
    copy:
      'Use the ready-to-go challenge at home, in class or for extra practice.',
  },
  {
    id: 'track',
    index: '03',
    title: 'Check and track',
    copy:
      'Use the included answer keys and printable progress tools to keep moving forward.',
  },
]
